module.exports = __webpack_public_path__ + "static/media/flowers_yorkshire_getty_desktop.c4cab444.jpg";